import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 残存価額の計算基準 */
enum ResidualValueCalcCriteria {
  one = 'CALC_ONE',
  two = 'CALC_TWO',
}

const nameConfig = {
  one: new Map([
    [Locale.ja, '計算式1：取得価額－取得価額×(1－残存率)'],
    [Locale.en, 'Calc One'],
  ]),
  two: new Map([
    [Locale.ja, '計算式2：取得価額×残存率'],
    [Locale.en, 'Calc Two'],
  ]),
};

const toEnum = rawValueToEnum(ResidualValueCalcCriteria, ResidualValueCalcCriteria.one);
const toDisplay = enumToName(ResidualValueCalcCriteria, nameConfig);
const toDisplayWithPrefix = enumToName(ResidualValueCalcCriteria, nameConfig, { prefix: true });

export const residualValueCalcCriteria = {
  enum: ResidualValueCalcCriteria,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ResidualValueCalcCriteria };
